import {AfterViewInit, Component, Injector, OnInit} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {FormGroup} from "@angular/forms";
import {ParameterService} from "../../_services/parameter.service";
import {AssociationService} from "../associactions/services/association.service";
import {AdminService} from "../dashboard/services/admin.service";

@Component({
    selector: 'app-user-man-ceu-detail',
    templateUrl: './user-man-ceu-detail.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class UserManCeuDetailComponent extends BaseComponentDirective implements OnInit {
    public form: FormGroup;

    unitBases: any = {};
    conditionTypes: any = {};
    documentTypes: any = {};
    integerLogics: any = {};

    association: any = {};

    user: any = null;
    subscription: any;

    activity: any = {};
    ceu: any = {}



    constructor(
        injector: Injector,
        private parameterService: ParameterService,
        private adminService: AdminService,
        private adminSvc: AdminService,
    ) {
        super(injector);

    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        await this.getUser(this.activatedRoute.snapshot.params.userId);

        this.conditionTypes = await this.parameterService.getParameterByName("CONDITION_TYPE");
        this.integerLogics = await this.parameterService.getParameterByName("INTEGER_LOGICAL_OPERATOR");
        this.unitBases = await this.parameterService.getParameterByName("UNIT_BASE");
        this.documentTypes = await this.parameterService.getParameterByName("DOCUMENT_TYPE");

        this.ceu = await this.adminService.getUserCEUById(this.activatedRoute.snapshot.params.documentId, this.activatedRoute.snapshot.params.userId);
        if(this.ceu.document.activityResponse) {
            this.activity = JSON.parse(this.ceu.document.activityResponse);
        }
    }



    goBack() {
        this.router.navigate(['/office/user/' + this.activatedRoute.snapshot.params.userId + '/editor'], {queryParams:{tab: 'ceus'}}).then()
    }

    async getUser(id: number) {
        this.subscription = await this.adminSvc.getAdminCheckActiveSubscription(id);
        this.adminSvc.getUserById(id).then(r => {
            this.user = r;


        }, _ => {
            return;
        });
    }
}
